import _ from 'lodash'

export const handleCourseData = (activeTab, value) => {
  const courses = _.get(activeTab, `[${value - 1}].courses`, [])
  return courses
    .filter((item) => item.status)
    .map((course) => _.get(course, 'course', {}))
}
